(function(window, document, $, undefined){
$(document).ready(function() {
    var nolopath = $('#nolopath');

    nolopath.on('semFormLoad', validateZip);

    nolopath.on('semFormLoad', getZip);

    nolopath.on('semFormLoad', insertCaseDescriptionPlaceholder);

    nolopath.on('semPageLoad', labelCaseDescription);

    nolopath.on('semPageLoad', submitButtonInsideCaseDescriptionContainer);

    nolopath.on('semPageLoad', labelSecondStep);

    nolopath.on('semPageLoad', labelBeforeLastStep);

    nolopath.on('semFormLoad', appendLabelBeforeLastStepButton);

    nolopath.on('semPageLoad', containerizeContactInformation);

    nolopath.on('semPageLoad', handelStepsProgressBar);

    nolopath.on('semFormLoad', handelStepsProgressBarCdApi1);

    nolopath.on('semError', restoreTopProgressBar);

    nolopath.on('semFormLoad', function() {
        if (!$('.page-nolosem-cd-api1, .page-nolosem-cd-api1pp').length) { return; }
        $('#nolopath')
            .off('input.ppv2progress change.ppv2progress blur.ppv2progress')
            .on('input.ppv2progress change.ppv2progress blur.ppv2progress', 'input, select, textarea', restoreTopProgressBar);
    });

    var $expandAnswerLinks = $('.expand-answer-link');

    $expandAnswerLinks.each(function () {
        $(this).on('click', function (e) {
            var $answerLink = $(e.target);
            var $collapsedAnswers = $answerLink.parent().find('.practice-info-answer__paragraph');

            $collapsedAnswers.toggleClass("collapse-answer");
            $answerLink.parent().toggleClass("expanded");
            
            $answerLink.text().trim() === 'Read More' ? $answerLink.text('Read Less') : $answerLink.text('Read More');
        });
    });
});


function getZip () {

    var $remoteZip = $('#zipInput');
    var $hiddenZip = $('#form-item-zip');

    if ($remoteZip.length === 0) {
        $hiddenZip.show();
    }
}


function validateZip () {
    var $firstStepBtn = $('.btn-sem-form-submit.first-step');
    var $zip = $('#zipInput');

    $firstStepBtn.on('click', function (e) {
        e.preventDefault();
        validateZipPattern();
    });

    $zip.on('change', validateZipPattern); // check and clear the error if pattern matches
}

function validateZipPattern () {
    var $zip = $('#zipInput');
    // EHCS-5739: on the geo variant, NON-EMPTY validation + messaging is handled by
    // nolo_path_google_places.js (the single '.geo-no-match-msg'). Only the EMPTY case falls
    // through here to show the standard "Invalid 5-digit US zip code" error (so an empty zip is
    // still caught) - avoiding a duplicate message when the user has typed something.
    if (document.querySelector('#nolopath.np-loc-geo') && $.trim($zip.val() || '') !== '') {
        $('.zip-error').remove();
        $zip.removeClass('error');
        return;
    }
    var pattern = /^[0-9]{5}$/;
    var inlineErrorHtml = "<div class='zip-error'>Invalid 5-digit US zip code</div>";
    var $zipForm = $('.zip-code-form');
    var $zipError = $('.zip-error');
    var zipCode = $zip.val();

    if (!pattern.test(zipCode)) {
        $zipError.remove();
        $zipForm.append(inlineErrorHtml);
        /* 
        ** Stupid workaround as the HTML is being re-rendered and 
        ** clears the error class that's being set, so a delay of 100ms seems to work it out
        */
        setTimeout(function() {
            $zip.addClass('error'); 
        }, 100);
    } else if ($zipError.length) {
        $zipError.remove();
        $zip.removeClass('error');
    }
}

function custom_emp_api2pp_contact_info() {
    // get reference to all contact info inputs
    var $formItemFirstName = $('#form-item-first_name');
    var $formItemLastName = $('#form-item-last_name');
    var $formItemEmail = $('#form-item-mail');
    var $formItemPhone = $('#form-item-phone');
    var $formFieldsetStepLast = $('.form-step-4');


    $formFieldsetStepLast.append('<div class="contact-info-container"></div>');

    var $contactInfoContainer = $('.contact-info-container');
    var $contactInfoContainerFirstName = $('.contact-info-first_name');
    var $contactInfoContainerLastName = $('.contact-info-last_name');

    var $contactInfoContainerEmail = $('.contact-info-email');
    var $contactInfoContainerPhone = $('.contact-info-phone');

    // append all inputs to newly created div
    $contactInfoContainer.append([
        $formItemFirstName,
        $formItemLastName,
        $formItemEmail,
        $formItemPhone
    ]);

    $contactInfoContainerFirstName.append([
        $formItemFirstName
    ])

    $contactInfoContainerLastName.append([
        $formItemLastName
    ])

    $contactInfoContainerEmail.append([
        $formItemEmail
    ])

    $contactInfoContainerPhone.append([
        $formItemPhone
    ]);
    if ($('#nolopath-form-emp-api2pp .checklist').length === 0) {
        const checkIcon = '<svg width="22" height="21" class="check-icon" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M11 0C8.9233 0 6.89323 0.615814 5.16652 1.76957C3.4398 2.92332 2.09399 4.5632 1.29927 6.48182C0.504549 8.40045 0.296614 10.5116 0.701759 12.5484C1.1069 14.5852 2.10693 16.4562 3.57538 17.9246C5.04383 19.3931 6.91476 20.3931 8.95156 20.7982C10.9884 21.2034 13.0996 20.9955 15.0182 20.2007C16.9368 19.406 18.5767 18.0602 19.7304 16.3335C20.8842 14.6068 21.5 12.5767 21.5 10.5C21.5 7.71523 20.3938 5.04451 18.4246 3.07538C16.4555 1.10625 13.7848 0 11 0ZM9.5 14.6931L5.75 10.9431L6.94296 9.75L9.5 12.3069L15.0575 6.75L16.2543 7.93943L9.5 14.6931Z" fill="#2093D2"/>' +
        '</svg>';

        const checklist =
        '<ul class="checklist">' +
        '<li>' + checkIcon + 'No win, no fee</li>' +
        '<li>' + checkIcon + 'No obligation to hire</li>' +
        '<li>' + checkIcon + '100% free evaluation</li>' +
        '</ul>';

        $('#nolopath-form-emp-api2pp').append(checklist);
    }

    $contactInfoContainer.prepend('<p>How can we reach you?</p>');
}

function custom_cd_api1_contact_info () {
    const urlParams = new URLSearchParams(window.location.search);

    // get reference to all contact info inputs
    var $formItemFirstName = $('#form-item-first_name');
    var $formItemLastName = $('#form-item-last_name');
    var $formItemEmail = $('#form-item-mail');
    var $formItemPhone = $('#form-item-phone');
    var $divForNameQuestions = $('<div class="name-questions"></div>');
    var $formFieldsetStepLast = $('.form-step-5');

    var isThreeSteps = $('.page-nolosem-ip-api2pp').length || $('.page-nolosem-re-api2pp').length 
            || $('.page-nolosem-talcumpowder-form2app').length || $('.page-nolosem-sexual-harassment-api2app').length
            || $('.page-nolosem-unemployment-api2app').length || $('.page-nolosem-wrongful-termination-api2app').length;

    if (isThreeSteps) {
        $formFieldsetStepLast = $('.form-step-3');
        if (!$('.page-nolosem-talcumpowder-form2app').length) {
            $('.form-subtitle').remove();
        }
    }

    $formFieldsetStepLast.append('<div class="contact-info-container"></div>');
    $divForNameQuestions.append([
        $formItemFirstName,
        $formItemLastName
    ]);
    var $contactInfoContainer = $('.contact-info-container');
    var $contactInfoContainerName = $('.contact-info-name');
    var $contactInfoContainerEmail = $('.contact-info-email');
    var $contactInfoContainerPhone = $('.contact-info-phone');

    // append all inputs to newly created div
    $contactInfoContainer.append([
        $divForNameQuestions,
        $formItemEmail,
        $formItemPhone
    ]);
    $contactInfoContainerEmail.append([
        $formItemEmail
    ])
    $contactInfoContainerName.append([
        $divForNameQuestions
    ]);
    $contactInfoContainerPhone.append([
        $formItemPhone
    ]);

    // add required label atop div
    labelContactInfoContainer();
}

function containerizeContactInformation () {
    const urlParams = new URLSearchParams(window.location.search);
    if ((urlParams.has('routing') && urlParams.get('routing') == 'pi5b')) {return;}
    if (window.location.href.includes("cd-api1d") && document.querySelector('body').getAttribute('data-pid') == 14) { 
        custom_cd_api1_contact_info();
        return; 
    }
    if (window.location.href.includes("emp-api2pp")) {
        custom_emp_api2pp_contact_info();
        return;
    }
    // get reference to all contact info inputs
    var $formItemFirstName = $('#form-item-first_name');
    var $formItemLastName = $('#form-item-last_name');
    var $formItemEmail = $('#form-item-mail');
    var $formItemPhone = $('#form-item-phone');
    var $divForNameQuestions = $('<div class="name-questions"></div>');
    var $formFieldsetStepLast = $('.form-step-4');

    var isThreeSteps = $('.page-nolosem-ip-api2pp').length || $('.page-nolosem-re-api2pp').length 
            || $('.page-nolosem-talcumpowder-form2app').length || $('.page-nolosem-sexual-harassment-api2app').length
            || $('.page-nolosem-unemployment-api2app').length || $('.page-nolosem-wrongful-termination-api2app').length;

    if (isThreeSteps) {
        $formFieldsetStepLast = $('.form-step-3');
        if (!$('.page-nolosem-talcumpowder-form2app').length) {
            $('.form-subtitle').remove();
        }
    }

    $formFieldsetStepLast.append('<div class="contact-info-container"></div>');
    $divForNameQuestions.append([
        $formItemFirstName,
        $formItemLastName
    ]);
    var $contactInfoContainer = $('.contact-info-container');
    var $contactInfoContainerName = $('.contact-info-name');
    var $contactInfoContainerEmail = $('.contact-info-email');
    var $contactInfoContainerPhone = $('.contact-info-phone');

    // append all inputs to newly created div
    $contactInfoContainer.append([
        $divForNameQuestions,
        $formItemEmail,
        $formItemPhone
    ]);
    $contactInfoContainerEmail.append([
        $formItemEmail
    ])
    $contactInfoContainerName.append([
        $divForNameQuestions
    ]);
    $contactInfoContainerPhone.append([
        $formItemPhone
    ]);

    // add required label atop div
    labelContactInfoContainer();
}

function handelStepsProgressBar() {
    var $isCdApi1Path = $('.page-nolosem-cd-api1');
    if($isCdApi1Path.length == 1) {
        var $progress = $("#nolopath-form-cd-api1").find(".form-loader.progress");
        if($progress.length) {
            $progress.show();
            var $progressBar = $progress.find('.progress-bar');
            if($progressBar.length) {
                $progressBar.show();
                const step = $isCdApi1Path.attr('data-path-step');
                const stepWidths = {
                    'step-1': '20%',
                    'step-2': '40%',
                    'step-3': '70%',
                    'step-4': '95%'
                };
                if(stepWidths[step]) {
                    $progressBar.css('width', stepWidths[step]);
                }
            }
        }

        var $progressTop = $isCdApi1Path.find(".form-loader.progress.progress-bar-top");
        if($progressTop.length) {
            var $progressTopBar = $progressTop.find('.progress-bar');
            if($progressTopBar.length) {
                const step = $isCdApi1Path.attr('data-path-step');
                const stepProgressWidths = {
                    'step-1': '0%',
                    'step-2': '25%',
                    'step-3': '50%',
                    'step-4': '75%'
                };
                if(stepProgressWidths[step]) {
                    $progressTopBar.css('width', stepProgressWidths[step]);
                }
                $progressTopBar.show();
                $progressTop.show();
                var $formStepLabel = $("#nolopath-form").find('h3.form-step-label');
                if($formStepLabel.length == 1) {
                    $formStepLabel.text('Step ' + step.charAt(step.length - 1) + ' of 4');
                }
            }
        }

        var $zip = $('#zipInput');
        if($zip.length) {
            var $firstStepBtn = $('.form-action-submit.btn-sem-form-submit');
            $firstStepBtn.on('click', function (e) {
                validateZipPattern();
            });
            $zip.on('change', validateZipPattern);
        }
    } else {
        var $isCdApi1ppPath = $('.page-nolosem-cd-api1pp');
        if($isCdApi1ppPath.length == 1) {
            var $progress = $("#nolopath-form-cd-api1pp").find(".form-loader.progress");
            if($progress.length) {
                $progress.show();
                var $progressBar = $progress.find('.progress-bar');
                if($progressBar.length) {
                    $progressBar.show()
                    if($isCdApi1ppPath.attr('data-path-step') == 'step-1') {
                        $progressBar.css('width','20%');
                    } else if($isCdApi1ppPath.attr('data-path-step') == 'step-2') {
                        $progressBar.css('width','40%');
                    } else if($isCdApi1ppPath.attr('data-path-step') == 'step-3') {
                        $progressBar.css('width','70%');
                    } else if($isCdApi1ppPath.attr('data-path-step') == 'step-4') {
                        $progressBar.css('width','95%');
                    }
                }
            }


            var $progressTop = $isCdApi1ppPath.find(".form-loader.progress.progress-bar-top");
            if($progressTop.length) {
                var $progressTopBar = $progressTop.find('.progress-bar');
                if($progressTopBar.length) {
                    const step = $isCdApi1ppPath.attr('data-path-step');
                    const stepProgressWidths = {
                        'step-1': '0%',
                        'step-2': '25%',
                        'step-3': '50%',
                        'step-4': '75%'
                    };
                    if(stepProgressWidths[step]) {
                        $progressTopBar.css('width', stepProgressWidths[step]);
                    }
                    $progressTopBar.show();
                    $progressTop.show();
                    var $formStepLabel = $("#nolopath-form").find('h3.form-step-label');
                    if($formStepLabel.length == 1) {
                        $formStepLabel.text('Step ' + step.charAt(step.length - 1) + ' of 4');
                    }
                }
            }

        }
    }

    var $isCdApid1Path = $('.page-nolosem-cd-api1d');
    if($isCdApid1Path.length == 1) {
        var $progress = $("#nolopath-form-cd-api1d").find(".form-loader.progress");
        if($progress.length) {
            $progress.show();
            var $progressBar = $progress.find('.progress-bar');
            if($progressBar.length) {
                $progressBar.show();
                const step = $isCdApid1Path.attr('data-path-step');
                const stepWidths = {
                    'step-1': '20%',
                    'step-2': '40%',
                    'step-3': '70%',
                    'step-4': '70%',
                    'step-5': '95%'
                };
                if(stepWidths[step]) {
                    $progressBar.css('width', stepWidths[step]);
                }
            }
        }

        var $zip = $('#zipInput');
        if($zip.length) {
            var $firstStepBtn = $('.form-action-submit.btn-sem-form-submit');
            $firstStepBtn.on('click', function (e) {
                validateZipPattern();
            });
            $zip.on('change', validateZipPattern);
        }
    } else {
        var $isCdApi1dppPath = $('.page-nolosem-cd-api1dpp');
        if($isCdApi1dppPath.length == 1) {
            var $progress = $("#nolopath-form-cd-api1dpp").find(".form-loader.progress");
            if($progress.length) {
                $progress.show();
                var $progressBar = $progress.find('.progress-bar');
                if($progressBar.length) {
                    $progressBar.show()
                    if($isCdApi1dppPath.attr('data-path-step') == 'step-1') {
                        $progressBar.css('width','20%');
                    } else if($isCdApi1dppPath.attr('data-path-step') == 'step-2') {
                        $progressBar.css('width','40%');
                    } else if($isCdApi1dppPath.attr('data-path-step') == 'step-3') {
                        $progressBar.css('width','70%');
                    } else if($isCdApi1dppPath.attr('data-path-step') == 'step-4') {
                        $progressBar.css('width','95%');
                    }
                }
            }
        }
    }

    var $isWcApi1Path = $('.page-nolosem-wc-api2');
    if($isWcApi1Path.length == 1) {
        var $progress = $("#nolopath-form-wc-api2").find(".form-loader.progress");
        if($progress.length) {
            $progress.show();
            var $progressBar = $progress.find('.progress-bar');
            if($progressBar.length) {
                $progressBar.show();
                const step = $isWcApi1Path.attr('data-path-step');
                const stepWidths = {
                    'step-1': '20%',
                    'step-2': '40%',
                    'step-3': '70%',
                    'step-4': '95%'
                };
                if(stepWidths[step]) {
                    $progressBar.css('width', stepWidths[step]);
                }
            }
        }

        var $zip = $('#zipInput');
        if($zip.length) {
            var $firstStepBtn = $('.form-action-submit.btn-sem-form-submit');
            $firstStepBtn.on('click', function (e) {
                validateZipPattern();
            });
            $zip.on('change', validateZipPattern);
        }

    } else {
        var $isWcApi1ppPath = $('.page-nolosem-wc-api2pp');
        if($isWcApi1ppPath.length == 1) {
            var $progress = $("#nolopath-form-wc-api2pp").find(".form-loader.progress");
            if($progress.length) {
                $progress.show();
                var $progressBar = $progress.find('.progress-bar');
                if($progressBar.length) {
                    $progressBar.show()
                    if($isWcApi1ppPath.attr('data-path-step') == 'step-1') {
                        $progressBar.css('width','20%');
                    } else if($isWcApi1ppPath.attr('data-path-step') == 'step-2') {
                        $progressBar.css('width','40%');
                    } else if($isWcApi1ppPath.attr('data-path-step') == 'step-3') {
                        $progressBar.css('width','70%');
                    } else if($isWcApi1ppPath.attr('data-path-step') == 'step-4') {
                        $progressBar.css('width','95%');
                    }
                }
            }
        }
    }
}

var _cdApi1ProgressWidth = '0%';

function handelStepsProgressBarCdApi1(event) {
    // semFormLoad fires per step with the step name in event.extraParameters.step.
    // We use this instead of body[data-path-step], which is set server-side and never
    // updated during AJAX transitions on hybrid-submit paths.
    var step = event && event.extraParameters ? event.extraParameters.step : null;
    var stepProgressWidths = { 'step-1': '0%', 'step-2': '25%', 'step-3': '50%', 'step-4': '75%' };
    if (!stepProgressWidths[step]) { return; }

    var $isCdApi1Path = $('.page-nolosem-cd-api1');
    var $isCdApi1ppPath = $('.page-nolosem-cd-api1pp');
    var $progressTop;
    if ($isCdApi1Path.length == 1) {
        $progressTop = $isCdApi1Path.find('.form-loader.progress.progress-bar-top');
    } else if ($isCdApi1ppPath.length == 1) {
        $progressTop = $isCdApi1ppPath.find('.form-loader.progress.progress-bar-top');
    } else {
        return;
    }

    // Update step label immediately
    var $formStepLabel = $('#nolopath-form').find('h3.form-step-label');
    if ($formStepLabel.length == 1) {
        $formStepLabel.text('Step ' + step.charAt(step.length - 1) + ' of 4');
    }

    // Defer width update past the synchronous toggleSubmitButton('enable') call that
    // follows loadNextStep. toggleSubmitButton sets display:none (overridden by CSS
    // !important) but this can reset CSS transitions, causing the animation to start
    // from 0% instead of the previous step's width.
    // Fix: disable transition → jump to previous width → reflow → re-enable → animate to target.
    var prevWidth = _cdApi1ProgressWidth;
    var targetWidth = stepProgressWidths[step];
    _cdApi1ProgressWidth = targetWidth;

    setTimeout(function() {
        if (!$progressTop.length) { return; }
        var $progressTopBar = $progressTop.find('.progress-bar');
        if (!$progressTopBar.length) { return; }
        $progressTopBar.css('transition', 'none');
        $progressTopBar.css('width', prevWidth);
        $progressTopBar[0].offsetWidth; // force reflow so the jump is processed
        $progressTopBar.css('transition', '');
        $progressTopBar.css('width', targetWidth);
    }, 0);
}

function restoreTopProgressBar() {
    var $path = $('.page-nolosem-cd-api1, .page-nolosem-cd-api1pp');
    if (!$path.length) { return; }
    var $progressTop = $path.find('.form-loader.progress.progress-bar-top');
    if ($progressTop.length) {
        $progressTop.css('display', 'block');
        $progressTop.find('.progress-bar').css('display', 'block');
    }
}

function labelContactInfoContainer () {
    var label = '<h3 class="last-step-label contact-info">Contact Information</h3>';
    var $contactInfoContainer = $('.contact-info-container');

    $contactInfoContainer.before(label);
    $('.form-wrapper').before(label);

    var $isEpApi1ppPath = $('.page-nolosem-ep-api1pp');
    if($isEpApi1ppPath.length == 1 && $isEpApi1ppPath.attr('data-path-step') == 'step-4') {
        $('h4.form-step-heading__step-last').text('Please provide your contact info to connect with an attorney — for free');
    }

    //cd-api1
    var $isCdApi1Path = $('.page-nolosem-cd-api1');
    if($isCdApi1Path.length == 1 && $isCdApi1Path.attr('data-path-step') == 'step-4') {
        $isCdApi1Path.find('h3.last-step-label.contact-info').text('Last step: Enter your details to find the right attorney for free');
        if ($isCdApi1Path.find('.form-trust-badges').length === 0) {
            var trustBadges = '<ul class="form-trust-badges">' +
                '<li class="form-trust-badge">$0 to connect</li>' +
                '<li class="form-trust-badge">No obligation</li>' +
                '<li class="form-trust-badge">Confidential</li>' +
                '</ul>';
            $isCdApi1Path.find('.form-actions .btn-group').after(trustBadges);
        }
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.show();
    } else if($isCdApi1Path.length == 1 && $isCdApi1Path.attr('data-path-step') == 'step-3') {
        var subDisclaimerDiv = '<div class="form-sub-disclaimer">You should not send any sensitive or confidential information through this site. Any information sent through this site does not create an attorney-client relationship and may not be treated as privileged or confidential. Information you provide on this site is subject to our privacy policy.</div>';
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        if(disclaimer.length == 1) {
            disclaimer.html(subDisclaimerDiv);
            disclaimer.show();
        }
    }

    var $isCdApi1ppPath = $('.page-nolosem-cd-api1pp');
    if($isCdApi1ppPath.length == 1 && $isCdApi1ppPath.attr('data-path-step') == 'step-4') {
        $isCdApi1ppPath.find('h3.last-step-label.contact-info').text('Last step: Enter your details to find the right attorney for free');
        if ($isCdApi1ppPath.find('.form-trust-badges').length === 0) {
            var trustBadges = '<ul class="form-trust-badges">' +
                '<li class="form-trust-badge">$0 to connect</li>' +
                '<li class="form-trust-badge">No obligation</li>' +
                '<li class="form-trust-badge">Confidential</li>' +
                '</ul>';
            $isCdApi1ppPath.find('.form-actions .btn-group').after(trustBadges);
        }
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.show();

    } else if($isCdApi1ppPath.length == 1 && $isCdApi1ppPath.attr('data-path-step') == 'step-3') {
        var subDisclaimerDiv = '<div class="form-sub-disclaimer">You should not send any sensitive or confidential information through this site. Any information sent through this site does not create an attorney-client relationship and may not be treated as privileged or confidential. Information you provide on this site is subject to our privacy policy.</div>';
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        if(disclaimer.length == 1) {
            disclaimer.html(subDisclaimerDiv);
            disclaimer.show();
        }
    }

    //cd-api1d
    var $isCdApid1Path = $('.page-nolosem-cd-api1d');
    if($isCdApid1Path.length == 1 && ($isCdApid1Path.attr('data-path-step') == 'step-5' || ($isCdApid1Path.attr('data-path-step') == 'step-4' && $isCdApid1Path.attr('data-pid') == '8937' ))) {
        $isCdApid1Path.find('h3.last-step-label.contact-info').text('Last step: Enter your details to find the right attorney for free');
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.clone(true, true).insertAfter('.form-step-questions');
        disclaimer.remove();
    } else if($isCdApid1Path.length == 1 && $isCdApid1Path.attr('data-path-step') == 'step-3') {
        var subDisclaimerDiv = '<div class="form-sub-disclaimer">You should not send any sensitive or confidential information through this site. Any information sent through this site does not create an attorney-client relationship and may not be treated as privileged or confidential. Information you provide on this site is subject to our privacy policy.</div>';
        $isCdApid1Path.find("#form-item-case_description").after(subDisclaimerDiv);
    }

    var $isCdApid1ppPath = $('.page-nolosem-cd-api1dpp');
    if($isCdApid1ppPath.length == 1 && ($isCdApid1ppPath.attr('data-path-step') == 'step-5' || ($isCdApid1ppPath.attr('data-path-step') == 'step-4' && $isCdApid1ppPath.attr('data-pid') == '8937'))) {
        $isCdApid1ppPath.find('h3.last-step-label.contact-info').text('Last step: Enter your details to find the right attorney for free');
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.clone(true, true).insertAfter('.form-step-questions');
        disclaimer.remove();

    } else if($isCdApid1ppPath.length == 1 && $isCdApid1ppPath.attr('data-path-step') == 'step-3') {
        var subDisclaimerDiv = '<div class="form-sub-disclaimer">You should not send any sensitive or confidential information through this site. Any information sent through this site does not create an attorney-client relationship and may not be treated as privileged or confidential. Information you provide on this site is subject to our privacy policy.</div>';
        $isCdApid1ppPath.find("#form-item-case_description").after(subDisclaimerDiv);
    }
    

    //wc-api2
    var $isWcApi2Path = $('.page-nolosem-wc-api2');
    if($isWcApi2Path.length == 1 && $isWcApi2Path.attr('data-path-step') == 'step-4') {
        $isWcApi2Path.find('h3.last-step-label.contact-info').text('Last Step: About You');
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.clone(true, true).insertAfter('.form-step-questions');
        disclaimer.remove();
        $("#nolopath-form").find('.form-disclaimer.hide').remove();
    }

    var $isWcApi2ppPath = $('.page-nolosem-wc-api2pp');
    if($isWcApi2ppPath.length == 1 && $isWcApi2ppPath.attr('data-path-step') == 'step-4') {
        $isWcApi2ppPath.find('h3.last-step-label.contact-info').text('Last Step: About You');
        var disclaimer = $("#nolopath-form").find('.form-disclaimer');
        disclaimer.clone(true, true).insertAfter('.form-step-questions');
        disclaimer.remove();
        $("#nolopath-form").find('.form-disclaimer.hide').remove();
    }
}

function insertCaseDescriptionPlaceholder () {
    var $isShApi1cPath = $('.page-nolosem-sexual-harassment-api2app');
    var $isUnEmpApi1cPath = $('.page-nolosem-unemployment-api2app');
    var $isWrnTermApi1cPath = $('.page-nolosem-wrongful-termination-api2app');
    var $isCdApi1 = $('.page-nolosem-cd-api1');
    var $isCdApi1pp = $('.page-nolosem-cd-api1pp');
    var $isCdApi1d = $('.page-nolosem-cd-api1d');
    var $isCdApi1dpp = $('.page-nolosem-cd-api1dpp');
    var $isDuiApi1ppePath = $('.page-nolosem-dui-api1ppe');
    var $caseDescriptionTextarea = $('#nolopath-qcase_description');
    var placeHolderMessage = 'Type your description here.';

    if($isShApi1cPath.length == 1 && $isShApi1cPath.attr('data-path-step') == 'step-2' || $isUnEmpApi1cPath.length == 1 && $isUnEmpApi1cPath.attr('data-path-step') == 'step-2'
    || $isWrnTermApi1cPath.length == 1 && $isWrnTermApi1cPath.attr('data-path-step') == 'step-2') {
        placeHolderMessage = '';
    }

    if($isDuiApi1ppePath.length != 1 && $isCdApi1.length != 1 && $isCdApi1pp.length != 1 && $isCdApi1d.length != 1 && $isCdApi1dpp.length != 1){
        $caseDescriptionTextarea.attr('placeholder', placeHolderMessage);
    }
}

function labelBeforeLastStep () {
    var isWcApi2fPath = $('.page-nolosem-cd-api1f').length;
    var isDuiApi1cPath = $('.page-nolosem-dui-api1c').length;
    if (isWcApi2fPath || isDuiApi1cPath) {
        var label = '<h4 class="panel-title before-last-step-label form-step-heading__step-3">Almost Done!</h4>'
        var $beforeLastStepDescriptionDiv = $('h4.panel-title.form-step-heading.form-step-heading__step-3');
        if ($('.before-last-step-label').length == 0) {
            $beforeLastStepDescriptionDiv.after(label);
        }
    }
}

function labelSecondStep() {
    var $isWtApi2fPath = $('.page-nolosem-wrongful-termination-api2app');
    var $isUnEmpApi1cPath = $('.page-nolosem-unemployment-api2app');
    var $isShApi1cPath = $('.page-nolosem-sexual-harassment-api2app');
    var $isOpApi1cPath = $('.page-nolosem-overtime-pay-api2app');
    if (($isOpApi1cPath.length == 1 && $isOpApi1cPath.attr('data-path-step') == 'step-2')) {
        var label = "Let's gather quick detail about your case";
        var $secondStepSubTitle = $('h4.panel-title.form-subtitle.visible-mobile.visible-xs');
        if ($secondStepSubTitle.length == 1) {
            $secondStepSubTitle.html(label);
        }
    } else if($isShApi1cPath.length == 1 && $isShApi1cPath.attr('data-path-step') == 'step-2' || $isUnEmpApi1cPath.length == 1 && $isUnEmpApi1cPath.attr('data-path-step') == 'step-2'
    || ($isWtApi2fPath.length == 1 && $isWtApi2fPath.attr('data-path-step') == 'step-2')) {
        var $secondStepTitle = $('h4.panel-title.form-step-heading.form-step-heading__step-2.visible-mobile');
        var $secondStepSubTitle = $('<h3 class="panel-title form-subtitle visible-mobile visible-xs"></h3>').text("Let's gather quick detail about your case.");
        $secondStepTitle.text('Step 2 of 3');
        setTimeout(function () {
            $secondStepTitle.after($secondStepSubTitle);
        }, 300);
    }
}

function labelCaseDescription () {
    const urlParams = new URLSearchParams(window.location.search);
    if ((urlParams.has('routing') && urlParams.get('routing') == 'pi5b')) {return;}
    if ($('.page-nolosem-cd-api1pp').length ==1 && $('.page-nolosem-cd-api1pp').attr('data-pid') == 83 && !$('#form-item-emplr_name').hasClass('hide') && (urlParams.has('questionnaire') && urlParams.get('questionnaire') == 'true')) {return;}
    var label = '<h3 class="last-step-label case-info">Case Description</h3>';
    var $caseDescriptionDiv = $('#form-item-case_description');

    $caseDescriptionDiv.before(label);
    $('.form-wrapper').before(label);
}

function appendLabelBeforeLastStepButton () {
    var isLabelled = $('.last-step-label.button-label').length
    var label = '<h3 class="last-step-label button-label">Our Lawyers Typically Respond in 1-2 Hours!</h3>';
    var $button = $('.btn-sem-form-submit.last-step');

    if (!isLabelled) {
        $button.before(label);
    }
}

function submitButtonInsideCaseDescriptionContainer () {
    if (!$('.page-nolosem-talcumpowder-form2a').length && !$('.page-nolosem-talcumpowder-form2app').length) {
        var $formActions = $('.form-actions').clone();
        var $caseDescriptionDiv = $('#form-item-case_description');
        $caseDescriptionDiv.append($formActions);
        $caseDescriptionDiv.find('.form-loader').remove();
        $caseDescriptionDiv.find('.form-action-submit').addClass('case-description-submit');
    }
}

})(window, document, jQuery);
